module.exports = __webpack_public_path__ + "static/media/zillow-custom.fcad0470.svg";